
<div >
    <video controls #videoPlayer
        (click)="onVideoClicked($event)"
        (keydown.enter)="onVideoClicked($event)"
        (keydown.space)="onVideoClicked($event)"
        (ended)="stopMedia()"
        (timeupdate)="onTimeUpdated($event)"
        (loadeddata)="onLoadedDataEnd($event)"
        [title]="options?.title"
        [tabindex]="0">
        <ng-container *ngFor="let video of options?.sources; let i = index">
            <source [src]="video.source" [type]="video.type" />
        </ng-container>            
    </video>
    <div class="controls" #controls>
        
        <button #playButton
            class="button-image"             
            aria-label="play pause toggle" 
            [title]="paused ? 'Play' : 'Pause'"
            (click)="onPlayClicked($event)">
            <img 
                [src]="player?.paused ? 'assets/images/Videoplayer/play.png' : 'assets/images/Videoplayer/pause.png'"
                alt="Play" />            
        </button>
        
        <button #stopButton
            class="button-image"             
            aria-label="stop" 
            title="Stop" 
            (click)="stopMedia()">
            <img src="assets/images/Videoplayer/stop.png" alt="Stop" />
        </button>
        
        <div class="timer" #timer>
            <div></div>
            <span aria-label="timer">00:00</span>
        </div>

        <div class="volume-slider-wrapper">
            <input #volumeControl              
                aria-label="Volume" 
                type="range" 
                class="volume-slider" 
                name="volControl" 
                [min]="0" [max]="1" 
                [value]="getVolumeLevel()" 
                [step]="0.1" 
                (input)="onVolumeChanged($event)"                
                [tabindex]="0"
                [title]="'Volume level'"
            />            
        </div>        
        
                
        <button #speakerButton
            class="button-image"           
            aria-label="Speakers" 
            title="Speakers"        
            (focus)="onSpeakerFocus($event)"
            (click)="onSpeakerClicked($event)">
            <img 
                [src]="!player?.muted ? 'assets/images/Videoplayer/speaker.png' : 'assets/images/Videoplayer/mute.png'"
                alt="Speaker" />
        </button>

        <button #rewindButton
            class="button-image"             
            aria-label="rewind" 
            title="Rewind"
            (click)="onRewindClicked($event)">
            <img 
                [src]="'assets/images/Videoplayer/rewind.png'"
                alt="Rewind" />
        </button>
        
        <button #fastForwardButton
            class="fwd button-image"             
            aria-label="fast forward" 
            title="Fast forward"
            (click)="onFastForwardClicked($event)">
            <img 
                [src]="'assets/images/Videoplayer/fast-forward.png'"
                alt="Fast forward" />
        </button>
    </div>
</div>




<!-- <figure>
    <video #target controls [title]="options?.title" preload="none" class="video-js">
            
    </video>
    <div>
       
    </div>
</figure> -->

<!-- <figure class="nsw-media">
    <div class="nsw-media__video">
      <iframe src="https://www.youtube.com/embed/HNHu2zRPSB4" title="Digital.nsw launch with Victor Dominello MP at NSW Parliament House" frameborder="0" allowfullscreen></iframe>
    </div>
    <figcaption>A long caption, ee mei labores adipiscing, nonumy reprehendunt ex mea umo tota has at, clita bonorum erroribus vis ne.</figcaption>
  </figure> -->